import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { ColorPaper } from '@/components/ui/Surface/ColorPaper';
import { AssignmentIcon, ChatIcon, FaceFrownOutlineIcon, } from '@/components/ui/SvgIcon/Variable/SvgIconComponents';
import { RfpProfessionalOneDescriptionContent } from './RfpProfessionalOneDescriptionContent';
/**
 * コンサルタント用に、案件依頼事項などのテキスト情報をまとめて表示するためのコンポーネント
 * @param props
 * @constructor
 */
export const RfpProfessionalOneDescriptionsColorPaper = (props) => {
    const { answerToSeek, className = '', description, issue } = props;
    const contentClassName = 'mb-20 last:mb-0';
    return (_jsxs(ColorPaper, Object.assign({ bgColor: 'lightGray', className: className, space: 'wide' }, { children: [issue && (_jsx(RfpProfessionalOneDescriptionContent, { className: contentClassName, icon: FaceFrownOutlineIcon, text: issue, title: '直面する課題' })), description && (_jsx(RfpProfessionalOneDescriptionContent, { className: contentClassName, icon: AssignmentIcon, text: description, title: '依頼事項' })), answerToSeek && (_jsx(RfpProfessionalOneDescriptionContent, { className: contentClassName, icon: ChatIcon, text: answerToSeek, title: '求める回答' }))] })));
};
